module.exports = __webpack_public_path__ + "static/media/marketing-feature-1.93fb361e.svg";